import React, { useEffect, useRef } from "react";
import LoadingScreen from "../../../components/LoadingScreen/LoadingScreen";
import Iconify from "../../../components/iconify/Iconify";
import { Button, Typography } from "@mui/material";
import { useGetMembersQuery } from "../../../features/members/membersApiSlice";
import MemberTable from "./MemberTable";
import { Icon } from "@iconify/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setDialog } from "../../../features/dialog/dialogSlice";

function MemberView({ defaultStatuses }) {
  const { data: members, isLoading } = useGetMembersQuery();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const openedMemberFromQuery = useRef(false);
  const focusMemberId = searchParams.get("focusMemberId") || "";
  const focusStatus = searchParams.get("focusStatus") || "";
  const focusAction = searchParams.get("focusAction") || "";

  useEffect(() => {
    const memberId = searchParams.get("memberId");
    if (!memberId || !Array.isArray(members) || openedMemberFromQuery.current) {
      return;
    }

    const foundMember = members.find((member) => String(member?._id) === memberId);
    if (!foundMember) return;

    openedMemberFromQuery.current = true;
    dispatch(
      setDialog({
        title: "Mitglied",
        type: "MEMBERACTIONS",
        data: { action: "SHOW", member: foundMember },
      }),
    );

    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete("memberId");
    setSearchParams(nextParams, { replace: true });
  }, [dispatch, members, searchParams, setSearchParams]);

  const handleClearFocus = () => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete("focusMemberId");
    nextParams.delete("focusStatus");
    nextParams.delete("focusAction");
    setSearchParams(nextParams, { replace: true });
  };

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!members) {
    return (
      <div style={{ textAlign: "center" }}>
        <div>
          <Iconify icon={"fa-solid:users"} width={250} height={250} />
        </div>
        <Typography variant="h3">Noch keine Mitglieder!</Typography>
      </div>
    );
  }

  return (
    <div>
      <Button
        onClick={() => navigate(-1)}
        variant="outlined"
        color="inherit"
        sx={{ mb: 3 }}
        startIcon={<Icon width="16" icon="fa-solid:arrow-left" />}
      >
        <Typography display={"inline"} variant="button" sx={{ mb: 0 }}>
          Zurück
        </Typography>
      </Button>
      {members && (
        <MemberTable
          members={members}
          defaultStatuses={defaultStatuses}
          focusMemberId={focusMemberId}
          focusStatus={focusStatus}
          focusAction={focusAction}
          onClearFocus={handleClearFocus}
        />
      )}
    </div>
  );
}

export default MemberView;
